<template>
  <video ref="videoPlayer" class="video-js" />
</template>

<script>
import videojs from "video.js/dist/alt/video.core.novtt.min.js";
import videojsLang from "video.js/dist/lang/pl.json";

import "video.js/dist/video-js.css";
import "%styles/video/video-player.scss";

export default {
  name: "video-player",

  data() {
    return {
      player: null
    };
  },

  props: {
    sources: Array,
    options: Object,
    thumbnail: String
  },

  created() {
    videojs.addLanguage("pl", videojsLang);
  },

  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      { ...this.options, sources: this.sources, poster: this.thumbnail },
      () => {}
    );
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },

  watch: {
    sources(newValue) {
      this.player.src(newValue);
    },

    thumbnail(newValue) {
      this.player.poster(newValue);
    }
  }
};
</script>

<style></style>
